// extracted by mini-css-extract-plugin
export var actions = "_tx-4";
export var item = "_tx-1";
export var price = "_tx-3";
export var quantity = "_tx-2";
export var table = "_tx-0";